import { CompanyNarratives } from '@/pages/Narrative/components/CompanyNarratives';
import { useFlag } from '@simplywallst/unleash';
import { CompanyNarratives as CompanyNarrativesDeprecated } from './CompanyNarratives';

type Props = {
  canonicalUrl: string;
};

export const FlaggedCompanyNarratives = ({ canonicalUrl }: Props) => {
  const { enabled, ready, variant } = useFlag(
    'mono-company-narratives-histogram-ssr'
  );

  if (enabled && ready && variant.enabled && variant.name === 'variant')
    return <CompanyNarratives canonicalUrl={canonicalUrl} />;

  return <CompanyNarrativesDeprecated canonicalUrl={canonicalUrl} />;
};
